import { Pipe, PipeTransform } from '@angular/core';
import { eSaleStatus } from 'src/app/models/eSaleStatus';

@Pipe({
	name: 'saleStatus'
})
export class SaleStatusPipe implements PipeTransform {

	transform(status:eSaleStatus) : string {
		switch (status) {
			case eSaleStatus.PENDING_PAYMENT : {
				return "Pago pendiente";
			}
			case eSaleStatus.APPROVED_PAYMENT : {
				return "Pago aprobado";
			}
			case eSaleStatus.PENDING_SHIPPING : {
				return "Listo para retirar";
			}
			case eSaleStatus.SHIPPING_DATE_SET : {
				return "Envío programado";
			}
			case eSaleStatus.IN_PROGRESS_DELIVERY : {
				return "En camino";
			}
			case eSaleStatus.RECEIVED : {
				return "Recibido";
			}
			case eSaleStatus.FAILED : {
				return "Envío fallido";
			}
			case eSaleStatus.CANCELED : {
				return "Cancelado";
			}
			default : {
				throw new Error("Invalid status");
			}
		}
	}

}
